// src/components/PracticeTest/FolderCard.jsx

import React from 'react';

export default function FolderCard({ title, count, onClick }) {
    return (
        <div className="folder-card" onClick={onClick}>
            <div className="folder-icon-wrapper">
                <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24">
                    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
                </svg>
            </div>
            <div className="folder-info">
                <h3>{title}</h3>
                <span className="folder-count">{count} Modules</span>
            </div>
        </div>
    );
}
